import { createFileRoute } from '@tanstack/react-router';
import { JobsPage, validateJobsSearch } from '@/features/settings/AgentsPages';

export const Route = createFileRoute('/app/settings/agents/jobs')({
  validateSearch: validateJobsSearch,
  component: function JobsRoute() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return <JobsPage search={search} onSearch={(s) => void navigate({ search: s, replace: true })} />;
  },
  staticData: { title: 'Jobs · Settings' },
});
